import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { baseUrl } from '../providers/AppDataProvider';

export interface TapGridBid {
  id: string;
  ref: string;
  pairId: string;
  currency: string;
  amount: string;
  coefficient: string;
  time1: number;
  time2: number;
  price1: string;
  price2: string;
  status: string;
  createdAt: string;
  refundAmount?: string;
}

async function getAuthHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
}

export async function fetchTapGridOpenBids(
  userId: string,
  limit = 20,
  offset = 0
): Promise<TapGridBid[]> {
  const headers = await getAuthHeaders();
  const response = await axios.get<TapGridBid[]>(
    `${baseUrl}/tap-grid/users/${userId}/open-bids?limit=${limit}&offset=${offset}`,
    { headers }
  );
  return response.data;
}

export async function fetchTapGridClosedBids(
  userId: string,
  limit = 20,
  offset = 0
): Promise<TapGridBid[]> {
  const headers = await getAuthHeaders();
  const response = await axios.get<TapGridBid[]>(
    `${baseUrl}/tap-grid/users/${userId}/closed-bids?limit=${limit}&offset=${offset}`,
    { headers }
  );
  return response.data;
}
